<template>
  <b-modal id="agregar-modelo" :title="$t('vModelo.agregarModelo')" centered size="lg" hide-footer
    ref="modalAgregarModelo" @hidden="resetModal">
    <b-form @submit.stop.prevent="createModelo">
      <p class="text-danger" v-if="existeNombre">
        El nombre ingresado ya está en uso. Por favor, ingrese un nombre
        diferente.
      </p>
      <div class="row">
        <b-col cols="12" sm="12" md="6">
          <label for="“marca”">{{ $t("vMarca.marca") }}* :</label>

          

          <b-form-select id="marca" v-model="selectedMarca" :options="marcas" value-field="id" text-field="marca"
            required>
            <template #first>
              <b-form-select-option :value="null" disabled>
                {{ $t("vMarca.elejirMarca") }}
              </b-form-select-option>
            </template>
          </b-form-select>


        </b-col>
        <b-col cols="12" sm="12" md="6">
          <label for="“nombre”">{{ $t("vModelo.modelo") }}* :</label>
          <b-form-input id="input-nombre" v-model="modelo.nombre" :state="estatusModelo"
            aria-describedby="input-nombre-help input-nombre-feedback" trim>
          </b-form-input>
          <b-form-invalid-feedback id="input-nombre-feedback">
            {{ $t("vModelo.msgModelo") }}
          </b-form-invalid-feedback>
        </b-col>
      </div>
      <div class="row">
        <div class="col-12 col-sm-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 d-lg-flex">
          <b-btn color="primary" class="w-100" style="color: white" @click="$bvModal.hide('agregar-modelo')">
            {{ this.$t("Gral.cancelar") }}
          </b-btn>
        </div>
        <div class="col-12 col-sm-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 sepracion-div-boton-guardar">
          <b-btn variant="info" class="w-100" style="color: white" type="submit"
            :disabled="estatusModelo === null || estatusModelo === false">
            {{ $t("vModelo.agregarModelo") }}
          </b-btn>
        </div>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
import ModelosDataService from "../../../services/ModelosDataService";
import MarcasDataService from "../../../services/MarcasDataService";
import AccionesDataService from "../../../services/AccionesDataService";
import Crypto from '../../../services/Crypto';
import { generalSweetAlert } from "../../../utils/Utils";

export default {
  data() {
    return {
      marcas: [],
      selectedMarca: null,
      modelo: {
        id: 0,
        nombre: "",
        marca: "",
        habilitado: true,
      },
      accion: "",
      usuarioLogueado: JSON.parse(sessionStorage.getItem("usuarioLogueado")),
      key: sessionStorage.getItem('key'),
      estatusModelo: null,
      existeNombre: false,
    };
  },

  computed: {
    validarModelo() {
      return this.modelo.nombre.trim().length >= 5;
    },
  },

  mounted() {
    this.obtenerMarcasHabilitadas()
  },

  watch: {
    "modelo.nombre"(data) {
      this.validarNombreModelo(data);
    },
  },

  methods: {

    validarNombreModelo(nombre) {
      if (!nombre || nombre.trim() === "") {
        this.estatusModelo = null;
        return;
      }

      this.estatusModelo = nombre.trim().length >= 5;
    },

    showModal() {
      this.$refs.modalAgregarModelo.show();
    },

    resetModal() {
      this.modelo.nombre = "";
      this.selectedMarca = null
      this.existeNombre = false
    },

    obtenerMarcasHabilitadas() {
      MarcasDataService.getAllHabilitadas().
        then(async (response) => {
          this.marcas = await Crypto.desencriptar(response.data, this.key);
        });
    },

    async createModelo() {
      try {
        const data = {
          modelo: this.modelo.nombre,
          marca: this.marcas.find((item) => item.id === this.selectedMarca),
          habilitado: this.modelo.habilitado,
        };

        const response = await ModelosDataService.create(data, this.key)
        if (response.status === 200) {
          this.$emit("actualizarTabla", response.status);
          this.selectedMarca = null;
          this.$refs.modalAgregarModelo.hide();
          this.accion = "Registró el modelo " + data.modelo;
          this.registrarAccion();

          generalSweetAlert('Modelo registrado exitosamente.', 'success')
        }
      } catch (error) {
        if (error.response.status === 406) {
          this.existeNombre = true;
          this.estatusModelo = false;
        }

        generalSweetAlert('Error al registrar el modelo.', 'error')
      }
    },

    registrarAccion() {
      const data = {
        usuario: this.usuarioLogueado,
        accion: this.accion + sessionStorage.infoDevice,
        fechaCreacion: new Date(),
        tipo: "accion",
      };
      AccionesDataService.create(data, this.key);
    }

  },
};
</script>

<style>
@media (max-width: 959px) {
  .sepracion-div-boton-guardar {
    margin-top: -12px;
  }
}

@media (min-width: 960px) {
  .sepracion-div-boton-guardar {
    margin-top: 0px;
  }
}
</style>
